export const findError = (e) => {
    return e ? typeof e == 'string' ? e
        : e.error ? e.error
        : e.message ? e.message
        : typeof e == 'object' ? JSON.stringify(e)
        : 'An unknown error occurred.'
        : 'An unknown error occurred.'
}

export const getStackTrace = function() {
    var obj = {};
    Error.captureStackTrace(obj, getStackTrace);
    return obj.stack;
};